/* eslint-disable import/no-anonymous-default-export */
/**
 * 쇼핑 캠페인 관리 설정
 */
import RefundBadge from "../components/RefundBadge";

function getStatusLabel(status) {
  switch (status) {
    case "waiting":
      return "대기중";
    case "active":
      return "활성화";
    case "expiringSoon":
      return "종료임박";
    case "terminated":
      return "종료";
    default:
      return status;
  }
}

export default {
  id: "adShopping",
  title: "[쇼핑 리워드]신청 관리",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type",
      params: { type: "shopping" },
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type/count",
      params: { type: "shopping" },
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    complete: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/refund",
      version: 2,
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/campaigns/by-type",
    },
  },

  filters: {
    default: {
      type: ["shopping"],
      keyword: "",
      submitDate: "",
      status: "전체",
      submitted: "전체",
      paid: "전체",
      page: 1,
      limit: 50,
    },
    schema: [
      {
        name: "type",
        label: "상품 타입",
        type: "checkbox-group",
        options: [{ value: "shopping", label: "쇼핑 리워드" }],
      },
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "신청자, 플레이스명",
      },
      {
        name: "submitDate",
        label: "접수일",
        type: "date",
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "active", label: "활성화" },
          { value: "expiringSoon", label: "종료임박" },
          { value: "terminated", label: "종료" },
        ],
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "activeCount", label: "활성화" },
      { key: "expiringSoonCount", label: "종료임박" },
      { key: "terminatedCount", label: "종료" },
    ],
  },

  table: {
    keyField: "adShoppingId",
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "신청자(ID)\n접수일\n상태",
        center: true,
        render: (row) => (
          <>
            <div>
              <span className="user-name">
                {row.userName}
                {row.userId ? ` (${row.userId})` : ""}
              </span>
            </div>
            <div>{row.submitDate || "-"}</div>
            <div>
              <span className={`badge badge-${row.status}`}>
                {getStatusLabel(row.status)}
              </span>
            </div>
          </>
        ),
      },
      {
        key: "period",
        label: "시작일\n종료일\n작업일수",
        center: true,
        render: (row) => (
          <>
            <div>{row.startDate || "-"}</div>
            <div>{row.endDate || "-"}</div>
            <div>{row.progressDays ? `${row.progressDays}일` : "-"}</div>
          </>
        ),
      },
      {
        key: "inflow",
        label: "총수량\n일수량\n총비용",
        center: true,
        render: (row) => (
          <>
            <div>{row.totalInflow?.toLocaleString() || 0}</div>
            <div>{row.dailyInflow?.toLocaleString() || 0}</div>
            <div>{row.totalCost?.toLocaleString() || 0}원</div>
          </>
        ),
      },
      {
        key: "productUrl",
        label: "상품URL",
        center: true,
        render: (row) =>
          row.productUrl ? (
            <a
              href={row.productUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {row.productUrl}
            </a>
          ) : (
            "-"
          ),
      },
      {
        key: "rankKeyword",
        label: "순위 조회용 키워드",
        center: true,
        render: (row) => (
          <>
            <div>{row.rankKeyword || "-"}</div>
          </>
        ),
      },
      {
        key: "workingKeywords",
        label: "작업키워드",
        center: true,
        render: (row) => (
          <>
            {Array.isArray(row.workingKeywords) &&
            row.workingKeywords.length > 0 ? (
              row.workingKeywords.map((keyword, idx) => (
                <div key={idx}>{keyword}</div>
              ))
            ) : (
              <div>-</div>
            )}
          </>
        ),
      },

      {
        key: "paymentType",
        label: "결제방법\n결제상태",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.paymentType === "card"
                ? "카드"
                : row.paymentType === "v_bank"
                  ? "가상계좌"
                  : row.paymentType === "account"
                    ? "계좌이체"
                    : row.paymentType === "point"
                      ? "포인트 결제"
                      : row.paymentType
                        ? row.paymentType
                        : "-"}
            </div>
            <div>
              {row.isRefunded === 1 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span className={`badge badge-${row.isPaid === 1 ? "결제완료" : "미결제"}`}>
                  {row.isPaid === 1 ? "결제완료" : "미결제"}
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "notification",
        label: "알림톡",
        center: true,
        render: (row) => {
          const productName = "쇼핑 리워드";

          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ""}
              data-purchase-amount={row.totalCost ?? ""}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : "메모"}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수\n취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        // submitted는 adCampaignMetaId 사용
        const selectedItems = items.filter((item) =>
          selectedIds.includes(item.adShoppingId),
        );
        const adCampaignMetaIds = [
          ...new Set(
            selectedItems
              .map((item) => item.adCampaignMetaId)
              .filter((id) => id),
          ),
        ];
        const hasUnsubmitted = selectedItems.some(
          (item) => item.isSubmitted !== 1,
        );
        return {
          type: "shopping",
          action: "submitted",
          ids: adCampaignMetaIds,
          toggleValue: hasUnsubmitted ? 1 : 0,
        };
      },
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some(
          (item) =>
            selectedIds.includes(item.adShoppingId) && item.isPaid === 1,
        );
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds, items) => {
        // paid는 adPaymentTransactionId 사용
        const selectedItems = items.filter((item) =>
          selectedIds.includes(item.adShoppingId),
        );
        const adPaymentTransactionIds = [
          ...new Set(
            selectedItems
              .map((item) => item.adPaymentTransactionId)
              .filter((id) => id),
          ),
        ];
        return {
          type: "shopping",
          action: "paid",
          ids: adPaymentTransactionIds,
          toggleValue: 1,
        };
      },
    },
    {
      id: "complete",
      label: "처리완료\n취소",
      actionType: "complete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        // complete는 각 캠페인 개별 ID (adShoppingId) 사용
        const selectedItems = items.filter((item) =>
          selectedIds.includes(item.adShoppingId),
        );
        const hasUncompleted = selectedItems.some(
          (item) => item.isTerminated !== 1,
        );
        return {
          type: "shopping",
          action: "completed",
          ids: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0,
        };
      },
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adShoppingId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const selectedCampaigns = items.filter((campaign) =>
          selectedIds.includes(campaign.adCampaignMetaId),
        );
        const hasInvalidCampaign = selectedCampaigns.some((campaign) => {
          const userName = campaign.userName || "";
          return (
            !userName.includes("테스트") &&
            !userName.includes("전유상") &&
            !userName.includes("이령빈") &&
            !userName.includes("서한석") &&
            !userName.includes("null") &&
            !userName.includes("채영호") &&
            !userName.includes("매니저")
          );
        });
        const hasNotTerminatedCampaign = selectedCampaigns.some(
          (campaign) =>
            !(campaign.status === "종료" && campaign.paid === "notComplete"),
        );
        return !(hasInvalidCampaign && hasNotTerminatedCampaign);
      },
      confirm: "선택한 쇼핑 캠페인을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds, items) => {
        const filteredSelectedIds = items
          .filter((item) => selectedIds.includes(item.adShoppingId))
          .map((item) => item.adShoppingId);
        return {
          type: "shopping",
          ids: filteredSelectedIds,
        };
      },
    },
  ],

  download: {
    type: "xlsx",
    fileName: "쇼핑캠페인_신청목록.xlsx",
    sheetName: "쇼핑캠페인신청목록",
    transformRow: (row) => ({
      신청자: row.userName || "",
      접수일: row.submitDate || "",
      상품URL: row.productUrl || "",
      순위키워드: row.rankKeyword || "",
      작업키워드: Array.isArray(row.workingKeywords)
        ? row.workingKeywords.join(", ")
        : "",
      시작일: row.startDate || "",
      종료일: row.endDate || "",
      진행일수: row.progressDays || 0,
      총유입: row.totalInflow || 0,
      일유입: row.dailyInflow || 0,
      총비용: row.totalCost || 0,
      수수료: row.fee || 0,
    }),
  },
};
